// extracted by mini-css-extract-plugin
module.exports = {"map":"styles-module--map--2gzER"};